import * as React from 'react';
import TopBar from "../../components/TopBarV2";
import Container from '@mui/material/Container';
import GlobalStyles from "@mui/material/GlobalStyles/GlobalStyles";
import Button from "@mui/material/Button/Button";
import Typography from "@mui/material/Typography/Typography";
import {useNavigate,useParams } from 'react-router-dom';
import firebase from "../../firebase/firebase";
import Stack from "@mui/material/Stack/Stack";
import Grid from "@mui/material/Grid/Grid";
import Box from "@mui/material/Box/Box";
import DownloadIcon from '@mui/icons-material/Download';
import FormControlLabel from "@mui/material/FormControlLabel/FormControlLabel";
import Checkbox from "@mui/material/Checkbox/Checkbox";
import Dialog from "@mui/material/Dialog/Dialog";
import DialogTitle from "@mui/material/DialogTitle/DialogTitle";
import IconButton from "@mui/material/IconButton/IconButton";
import CloseIcon from "@mui/material/SvgIcon/SvgIcon";
import DialogContent from "@mui/material/DialogContent/DialogContent";
import DialogContentText from "@mui/material/DialogContentText/DialogContentText";
import DialogActions from "@mui/material/DialogActions/DialogActions";
import Portal from "@mui/material/Portal";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import {useContext} from "react";
import {AuthUserContext} from "../../providers/AuthProvider";
import ScrollToTop from '../../utils/scrollTop';
import NumberFormat from "../../helpers/number-format";


export default function InvestorMilestones(){
  const milestones = [
    {
      milestone: 'Upon post-production completion',
      releaseValue: 2000,
      dueDate: 'AUG 18,22',
      status: ''
    },
    {
      milestone: 'Upon post-production completion',
      releaseValue: 2000,
      dueDate: 'JUL 20,22',
      status: ''
    },
    {
      milestone: 'Upon post-production completion',
      releaseValue: 2000,
      dueDate: 'SEP 30,22',
      status: ''
    },
    {
      milestone: 'Upon post-production completion',
      releaseValue: 2000,
      dueDate: 'OCT 10,22',
      status: ''
    }
  ]
  const storageRef = firebase.storage().ref();
  const [open, setOpen] = React.useState(false);
  const [openTERM, setOpenTERM] = React.useState(false);
  const [termBool, setTermBool] = React.useState(false);
  const handleClose = () => {
    setOpen(false);

  };
  const NotNowhandleClose = () => {
    setOpen(false);
  };
  const handleCloseTERM = () => {
    setOpenTERM(false);
  }

  const handleGoToDashboard = () => {
    navigator('/investor/dashboard');
  }
  const [project, setProject] = React.useState();
  const { user, profile} = useContext(AuthUserContext);
  let { projectId } = useParams();
  const navigator = useNavigate()
  function getSum(total, num) {
    return total + Math.round(num.amount);
  }
  const downloadURL = (url) => new Promise(((resolve, reject) => {
    const mediaRef = storageRef.child(url);

// Get the download URL
    mediaRef.getDownloadURL()
      .then((url) => {
        resolve(url);
        // setImageUrl(url)
        // setLoading(false)
        // Insert url into an <img> tag to "download"
      })
      .catch((error) => {
        reject(error)
        // setLoading(false)

        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
          case 'storage/object-not-found':
            // File doesn't exist
            break;
          case 'storage/unauthorized':
            // User doesn't have permission to access the object
            break;
          case 'storage/canceled':
            // User canceled the upload
            break;

          // ...

          case 'storage/unknown':
            // Unknown error occurred, inspect the server response
            break;
        }
      });
  }))
  React.useEffect(() => {
    const projectRef = firebase.firestore().collection('projects').doc(projectId);

    projectRef.get().then(async (doc) => {
      const path = await downloadURL(doc.data().contract.contactPath)
      setProject({...doc.data(), downloadURL: path})
    });
  }, [])
  const sendConratcAndstartChat = async () => {
    const contractRef = firebase.firestore().collection('contracts');
    const messageRef = firebase.firestore().collection('messages');
    try{
      let contract;
      const contractSnapshot = await contractRef
      .where('uid', '==', user.uid)
      .where('projectId', '==', projectId)
      .get();

      if(contractSnapshot.empty) {
        contract = await contractRef.add({
          uid: user.uid,
          name: profile?.name,
          createdAt:firebase.firestore.FieldValue.serverTimestamp(),
          projectId,
          creator:{
            id: project?.uid,
            name: project?.creatorName,
          },
          milestones: project?.contract?.millstones,
          status:'draft'
        });
      } else {
        contractSnapshot.forEach((doc) => {
          contract =  doc.data();
          contract.id = doc.id;
          return;
        });
      }

      let room;
      const roomRef = await firebase.firestore().collection('rooms');
      const roomSnapshot =  await roomRef
      .where('createdBy', '==', user.uid)
      .where('projectId', '==', projectId)
      .where('contractId', '==', contract.id )
      .get();

      if(roomSnapshot.empty) {
        room = await roomRef.add({
          createdBy: user.uid,
          participates:[project?.uid, user.uid],
          updatedAt:firebase.firestore.FieldValue.serverTimestamp(),
          createdAt:firebase.firestore.FieldValue.serverTimestamp(),
          contractId: contract?.id,
          projectId,
          projectTitle: project?.title
        })
      } else {
        roomSnapshot.forEach((doc) => {
          room =  doc.data();
          room.id = doc.id;
          return;
        });
      }

      const messageSnapshot =   await messageRef
      .where('roomId', '==', room.id)
      .get();

      if( messageSnapshot.empty) {
        await messageRef.add(
          {
            text: `Please go ahead and upload your signed contract`,
            type: 'created-message',
            sender:  user.uid,
            receiver: project?.uid,
            createdAt:firebase.firestore.FieldValue.serverTimestamp(),
            roomId: room?.id,
            read:false,
            status: 'send'
          }
        )
      }
      else {
        console.log(room?.id)
        await roomRef.doc(room?.id).update({
          updatedAt:firebase.firestore.FieldValue.serverTimestamp()
        })
      }


      navigator('/investor/chat')
      /*TODO: navigate to project details view layer 3*/
    } catch (e) {
      console.log(e);
    }
  }
  return (
    <React.Fragment>
      <ScrollToTop/>
      <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
      {/* Hero unit */}
      {/*<TopBar showBar={true}/>*/}
      <Container maxWidth="fullWidth" sx={{backgroundColor: '#E3E8F0', paddingY: 8,  mb: 8, textAlign:'left'}}>
        <Container maxWidth="lg">
          <Typography variant={'h4'} sx={{pl: 2}} color={'primary'}>
            PROJECTS DETAILS
          </Typography>

        </Container>
      </Container>
      <Container maxWidth="lg" sx={{textAlign:'left' }}>
        <Grid container spacing={10} sx={{pl:2, pb: 5}}>
          <Grid item  xs={12} sm={12} md={8}>
            <Stack direction={'column'} spacing={3}>
              <Typography variant={'h5'}>
                Milestone payments
              </Typography>

              <Box sx={{marginY: 5, height: 1.5, borderTop: '1px solid #363636'}}/>
              <Stack direction={'column'} spacing={3}>
                <Stack direction={'row'} spacing={3} sx={{width:'100%'}}>

                  <Typography variant={'body2'} sx={{flex: 1, borderRadius:'14px', p: 1.75 , textAlign:'center', fontWeight:600}}>
                   Description
                  </Typography>
                  <Typography variant={'body2'} sx={{  borderRadius:'14px', p: 1.75, paddingX: 3 , textAlign:'center', fontWeight:600}}>
                    Amount
                  </Typography>
                  <Typography variant={'body2'} sx={{  borderRadius:'14px', p: 1.75, paddingX: 3, textAlign:'center', fontWeight:600 }}>
                    Deadline
                  </Typography>
                </Stack>
                {
                  project && project?.contract && project?.contract?.millstones && project?.contract?.millstones.length > 0 &&
                  project?.contract?.millstones.map(d =>
                    <Stack direction={'row'} spacing={3} sx={{width:'100%'}}>

                      <Typography variant={'body2'} sx={{flex: 1, backgroundColor:'#ECF3FF', border: '1px solid #363636', p: 1.75 }}>
                        {d?.description}
                      </Typography>
                      <Typography variant={'body2'} sx={{ border: '1px solid #363636', p: 1.75, paddingX: 3 }}>
                         {Intl.NumberFormat().format(d?.amount)}
                      </Typography>
                      <Typography variant={'body2'} sx={{ border: '1px solid #363636', p: 1.75, paddingX: 3 }}>
                        {d?.deadLine}
                      </Typography>
                    </Stack>
                  )
                }
              </Stack>
              <Typography variant={'h5'} sx={{marginY: 5,}}>
                Your investment
              </Typography>
              <Stack direction={'row'} spacing={5} sx={{width:'100%', borderBottom:'1px solid #363636', paddingY: 2}}>
                <Typography variant={'body1'} sx={{fontWeight: '600', flex: .5}}>
                  { `${ (project && project?.contract && project?.contract?.howMuchInvestors && (parseInt(project?.contract?.howMuchInvestors ) > 1)) ? 'Partial investment amount range:' : 'Full Amount'}` }
                </Typography>
                <Typography variant={'body1'} sx={{fontWeight: '600'}}>
                  $ {Intl.NumberFormat().format(
                  (project && project?.contract && project?.contract?.howMuchInvestors && (parseInt(project?.contract?.howMuchInvestors ) > 1))
                  ? project && `${project.contract.minimumInvestment} - ${project.contract.maximumInvestment}`
                  : project && project.budget
                  
                  )}
                </Typography>
              </Stack>
              <Typography variant={'body2'} sx={{marginY: 2}}>
                { `A ${ (project && project?.contract && project?.contract?.howMuchInvestors && (parseInt(project?.contract?.howMuchInvestors ) > 1)) ? 'partial' : 'full'} investor was requested by the creator for this project.` }<br/>
                If you agree with this terms, you will be the only investor for this project.
              </Typography>
              <span/>
              <Stack direction={'row'} spacing={2} justifyContent="flex-start"
                     alignItems="center">
                <Box sx={{
                  width: 32,
                  height: 41,
                  background: '#ED1C24',
                  borderRadius: '3px',
                  color:'#fff',
                  fontSize:'small',
                  py: 1.5,
                  px:.6,
                  textTransform:'uppercase'
                }} >

                  {project && project?.contract && project?.contract?.contactPath.split('.')[project?.contract?.contactPath.split('.').length -1]}</Box>
                <Typography variant={'body2'} sx={{fontWeight: 600, flex:1}} >
                  {project && project?.contract && project?.contract?.contactPath.split('/')[project?.contract?.contactPath.split('/').length -1]}
                </Typography>
                <Button variant={'outlined'}  color={'primary'} startIcon={<FileDownloadOutlinedIcon/>} href={project?.downloadURL} download target={'_blank'}>
                  Download contract
                </Button>
              </Stack>
              {/*
              onChange={(e) =>
                setNdaBool(e.target?.checked)
              }
              */}
              <FormControlLabel value={termBool} onChange={(e) =>
              setTermBool(e.target?.checked)} control={<Checkbox />} label={<Typography variant={'body2'} sx={{fontWeight: 600}} >I can confirm that I have read and agree with the terms above</Typography>}

              />


            </Stack>
          </Grid>
          <Grid item  xs={12} sm={12} md={4}>
            <Stack direction={'column'} specing={3}>
              <Box sx={{  backgroundColor:'#ECF3FF'}}>
                <Stack direction={'column'} sx={{p: 2}} spacing={3}>
                  <Typography variant={'caption'}>
                    Pay by Progress.<br/>
                    How does Milestone Payment Work?
                  </Typography>
                  <Stack direction={'row'} spacing={4} justifyContent="center"
                         alignItems="end">
                    <Stack direction='column'>
                      <img src="/assets/icons/flag-milestones.png" style={{height:140, width:140}} alt=""/>
                      <Typography variant={'caption'}>
                        1. Milestone created.
                      </Typography>
                    </Stack>
                    <img src="/assets/icons/arrow-1.png"  alt=""/>

                  </Stack>
                  <Stack direction={'row'}  justifyContent="center"
                         alignItems="flex-end" spacing={4}>

                    <img src="/assets/icons/arrow-2.png"  alt=""/>
                    <Stack direction='column'>
                      <img src="/assets/icons/credit-card.png" style={{height:117, width:117}} alt=""/>
                      <Typography variant={'caption'} >
                        2. your funds are<br/>
                        held securely.
                      </Typography>
                    </Stack>

                  </Stack>
                  <Stack direction={'row'} specing={8} justifyContent="center"
                         alignItems="center">
                    <Stack direction='column'>
                      <img src="/assets/icons/give.png" style={{height:110, width:110}} alt=""/>
                      <Typography variant={'caption'}>
                        3. released once <br/>
                        you are satisfied.
                      </Typography>
                    </Stack>
                    <img src="/assets/icons/arrow-1.png" style={{opacity:0, flex: .8}} alt=""/>


                  </Stack>

                </Stack>
              </Box>
            </Stack>
          </Grid>
        </Grid>

        <Stack direction={'row'}  justifyContent="center"
               alignItems="center" spacing={5} my={5}>
          {/* <Button variant={'link'} sx={{textDecoration: 'underline'}} >
            Go Back
          </Button> */}


          <Button variant={'contained'} onClick={() => !termBool ? setOpen(true) : sendConratcAndstartChat()}>
            Upload signed contract
          </Button>
          <Portal >
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"

            >
              <DialogTitle id="alert-dialog-title" >
                <Stack direction={'row'} spacing={2}>
                  <Typography variant={'h6'} sx={{flex:1}}>Before you move forward...</Typography>
                  <IconButton sx={{color:'rgba(0, 0, 0, 0.87)'}} onClick={() => setOpen(false)}>
                    <CloseIcon/>
                  </IconButton>
                </Stack>
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description" >
                  <Typography variant={'body2'} >Without agreeing to the terms and conditions, you cannot move forward.<br></br> Would you like to view other projects?</Typography>
                </DialogContentText>
              </DialogContent>
              <DialogActions sx={{paddingX: 3, paddingY: 2}}>
                <Button onClick={NotNowhandleClose} size={'small'} sx={{color: '#000',paddingX: 3, textDecoration: "underline"}}>Maybe Later</Button>
                <Button  variant={'contained'} color={'warning'} sx={{paddingX: 3}} size={'small'} onClick={()=> {
                  navigator(-2)
                }}


                 >

                  Go to dashboard
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              open={openTERM}
              onClose={handleCloseTERM}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"

            >
              <DialogTitle id="alert-dialog-title" >
                <Stack direction={'row'} spacing={2}>
                  <Typography variant={'h6'} sx={{flex:1}}>The next step </Typography>
                  <IconButton sx={{color:'rgba(0, 0, 0, 0.87)'}} onClick={() => setOpenTERM(false)}>
                    <CloseIcon/>
                  </IconButton>
                </Stack>
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description" >
                  <Typography variant={'body2'} >We will notify you when the NDA is verified by the admin. Please note that this can take upto 2 weeks.</Typography>
                </DialogContentText>
              </DialogContent>
              <DialogActions sx={{paddingX: 3, paddingY: 2}}>
                <Button  variant={'contained'} color={'warning'} sx={{paddingX: 3}} size={'small'} onClick={handleGoToDashboard} >
                  Go to dashboard
                </Button>
              </DialogActions>
            </Dialog>

          </Portal>
         </Stack>
      </Container>

      <Container maxWidth="lg" sx={{textAlign:'left' }}>

      </Container>

    </React.Fragment>
  );
}
